export default "__VITE_ASSET__Bev$YK$m__"